import { CREATE_ATTRIBUTE, CREATE_ATTRIBUTE_SUCCESS, CREATE_ATTRIBUTE_ERROR, CREATE_ATTRIBUTE_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateAttribute = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ATTRIBUTE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_ATTRIBUTE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: action?.payload?.message,
      };
      break;

    case CREATE_ATTRIBUTE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_ATTRIBUTE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateAttribute;
